const DEFAULT_TIME_RANGE = {
    pastDuration: '1h'
};
export { DEFAULT_TIME_RANGE };

//# sourceMappingURL=time-range-defaults.js.map